import React from 'react';

//component for the not found message when no image results are found
function NotFound() {
    return (<div className="photo-container">
    <h2>Page not found!</h2>
    </div>);
  }

  export default NotFound;